import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { DecodeStream } from './DecodeStream.js';
var textEncoder = new TextEncoder();
var isBigEndian = new Uint8Array(new Uint16Array([0x1234]).buffer)[0] == 0x12;
export var EncodeStream = /*#__PURE__*/function () {
  function EncodeStream(buffer) {
    _classCallCheck(this, EncodeStream);
    this.buffer = buffer;
    this.view = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
    this.pos = 0;
  }
  _createClass(EncodeStream, [{
    key: "writeBuffer",
    value: function writeBuffer(buffer) {
      this.buffer.set(buffer, this.pos);
      this.pos += buffer.length;
    }
  }, {
    key: "writeString",
    value: function writeString(string) {
      var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ascii';
      var buf;
      switch (encoding) {
        case 'utf16le':
        case 'utf16-le':
        case 'ucs2':
          // node treats this the same as utf16.
          buf = stringToUtf16(string, isBigEndian);
          break;
        case 'utf16be':
        case 'utf16-be':
          buf = stringToUtf16(string, !isBigEndian);
          break;
        case 'utf8':
          buf = textEncoder.encode(string);
          break;
        case 'ascii':
          buf = stringToAscii(string);
          break;
        default:
          throw new Error("Unsupported encoding: ".concat(encoding));
      }
      this.writeBuffer(buf);
    }
  }, {
    key: "writeUInt24BE",
    value: function writeUInt24BE(val) {
      this.buffer[this.pos++] = val >>> 16 & 0xff;
      this.buffer[this.pos++] = val >>> 8 & 0xff;
      this.buffer[this.pos++] = val & 0xff;
    }
  }, {
    key: "writeUInt24LE",
    value: function writeUInt24LE(val) {
      this.buffer[this.pos++] = val & 0xff;
      this.buffer[this.pos++] = val >>> 8 & 0xff;
      this.buffer[this.pos++] = val >>> 16 & 0xff;
    }
  }, {
    key: "writeInt24BE",
    value: function writeInt24BE(val) {
      if (val >= 0) {
        this.writeUInt24BE(val);
      } else {
        this.writeUInt24BE(val + 0xffffff + 1);
      }
    }
  }, {
    key: "writeInt24LE",
    value: function writeInt24LE(val) {
      if (val >= 0) {
        this.writeUInt24LE(val);
      } else {
        this.writeUInt24LE(val + 0xffffff + 1);
      }
    }
  }, {
    key: "fill",
    value: function fill(val, length) {
      if (length < this.buffer.length) {
        this.buffer.fill(val, this.pos, this.pos + length);
        this.pos += length;
      } else {
        var buf = new Uint8Array(length);
        buf.fill(val);
        this.writeBuffer(buf);
      }
    }
  }]);
  return EncodeStream;
}();
function stringToUtf16(string, swap) {
  var buf = new Uint16Array(string.length);
  for (var i = 0; i < string.length; i++) {
    var code = string.charCodeAt(i);
    if (swap) {
      code = code >> 8 | (code & 0xff) << 8;
    }
    buf[i] = code;
  }
  return new Uint8Array(buf.buffer);
}
function stringToAscii(string) {
  var buf = new Uint8Array(string.length);
  for (var i = 0; i < string.length; i++) {
    // Match node.js behavior - encoding allows 8-bit rather than 7-bit.
    buf[i] = string.charCodeAt(i);
  }
  return buf;
}
var _iterator = _createForOfIteratorHelper(Object.getOwnPropertyNames(DataView.prototype)),
  _step;
try {
  var _loop = function _loop() {
    var key = _step.value;
    if (key.slice(0, 3) === 'set') {
      var type = key.slice(3).replace('Ui', 'UI');
      if (type === 'Float32') {
        type = 'Float';
      } else if (type === 'Float64') {
        type = 'Double';
      }
      var bytes = DecodeStream.TYPES[type];
      EncodeStream.prototype['write' + type + (bytes === 1 ? '' : 'BE')] = function (value) {
        this.view[key](this.pos, value, false);
        this.pos += bytes;
      };
      if (bytes !== 1) {
        EncodeStream.prototype['write' + type + 'LE'] = function (value) {
          this.view[key](this.pos, value, true);
          this.pos += bytes;
        };
      }
    }
  };
  for (_iterator.s(); !(_step = _iterator.n()).done;) {
    _loop();
  }
} catch (err) {
  _iterator.e(err);
} finally {
  _iterator.f();
}